/**
 * Installs the event panel.
 *
 * Self-mounting: it creates its own container and renders into it rather than joining the
 * app's React tree. That keeps the wiring in `app/index.jsx` to a single guarded dynamic
 * import -- which is what lets Rollup remove the whole feature from the production bundle
 * -- and it means the panel survives the app re-rendering, erroring, or being replaced by
 * the "Cannot Load Application" state, which are exactly the moments you want to read the
 * log.
 */
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import {render} from 'react-dom';

import DebugPanel from './DebugPanel';
import {tapAxios, tapFetch, tapMixpanel} from './taps';

const CONTAINER_ID = 'refi-debug-events';

let installed = false;

export const install = () => {
    if (installed || typeof document === 'undefined') {
        return null;
    }

    installed = true;

    tapMixpanel(mixpanel);
    tapAxios(axios);
    // The funnel rail. Only installed when the panel is on, so production never sees a
    // wrapped global fetch.
    tapFetch();

    const container = document.createElement('div');

    container.id = CONTAINER_ID;
    document.body.appendChild(container);

    render(<DebugPanel />, container);

    return container;
};

export {clear, getEntries, subscribe} from './eventLog';
